var map = {
	"./dc-arrow.jpg": 35,
	"./dc-batman.jpg": 36,
	"./dc-black.jpg": 37,
	"./dc-blue.jpg": 38,
	"./dc-flash.jpg": 39,
	"./dc-green.jpg": 40,
	"./dc-martian.jpg": 41,
	"./dc-robin.jpg": 42,
	"./dc-superman.jpg": 43,
	"./dc-wonder.jpg": 44,
	"./marvel-captain.jpg": 45,
	"./marvel-cyclops.jpg": 46,
	"./marvel-daredevil.jpg": 47,
	"./marvel-hawkeye.jpg": 48,
	"./marvel-hulk.jpg": 49,
	"./marvel-iron.jpg": 50,
	"./marvel-pipe.jpg": 51,
	"./marvel-silver.jpg": 52,
	"./marvel-spider.jpg": 53,
	"./marvel-thor.jpg": 54,
	"./marvel-wolverine.jpg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;